module.exports = __webpack_public_path__ + "static/media/icon.4ac4badf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon.png
// module id = 128
// module chunks = 0